import { FC } from 'react'
import { PortfolioProvider } from './usePortfolioContext'
import { Outlet } from 'react-router-dom'

export const PortfolioManagement: FC = () => {
  return (
    <PortfolioProvider>
      <Outlet />
    </PortfolioProvider>
  )
}
